/**
 * Vendor Settings buttons.
 */
 export enum VendorSettingsButtons {
    INFO = "info",
    HOME = "home",
    FAST_PLAY = "fast_play",
    SPACE_TO_SPIN = "space_to_spin",
    SWIP_REELS = "swip_reels",
    STOP_ON_ANY_WIN = "stop_on_any_win",
    PAYTABLE = "paytable",
    SETTINGS = "settings",
    GAME_INFO = "gameinfo",
    SKIP_INTRO = "skip_intro"
}
